import React, { useEffect, useState } from "react";
import "./subscriptionform.css";
import { Select, MenuItem } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import { handleToast, isValuePresent } from "../../../utils";
// import { updateSubscription } from "../../../services/api/subscription";
import { toast } from "react-toastify";

export default function SubscriptionForm({ data }) {
  const navigate = useNavigate();
  const isMobile = window.innerWidth <= 600;
  const [Name, setName] = useState(data.name || "");
  const [Amount, setAmount] = useState(data.base_price || "");
  const [state, setState] = useState(data.is_default || false);
  const [trialDays, setTrialDays] = useState(data.trial_days || "");
  const [trialCharge, setTrialCharge] = useState(data.trial_charge || "");
  const [description, setDescription] = useState(data.description || "");
  const [duration, setDuration] = useState(data.duration || "");
  const [timeframe, setTimeframe] = useState(data.timeframe || "");
  const getCoins = data.get_coins ?? "";
  const gstPercentage = data.gst_percentage ?? 18;
  const finalPriceWithGst = data.final_price_with_gst ?? "";

  const [loader, setLoader] = useState(false);
  const [IsTrue, setIstrue] = useState(true);

  const requiredFields = [
    Name,
    Amount,
    state,
    trialDays,
    trialCharge,
    description,
    duration,
    timeframe,
  ];

  /** ✅ SAME OBJECT AS CREATE FORM */
  const subscriptionObj = {
    id: data.id,
    name: Name,
    base_amount: Amount,
    is_default: state,
    trial_days: trialDays,
    trial_charge: trialCharge,
    description,
    duration,
    timeframe,
  };

  useEffect(() => {
    const isAllFilled = requiredFields.some(
      (field) => !isValuePresent(field)
    );
    setIstrue(isAllFilled);
  }, [...requiredFields]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    // try {
    //   updateSubscription(JSON.stringify(subscriptionObj))
    //     .then((response) => {
    //       if (response.data.status === "success") {
    //         toast.success(response?.data?.message, {
    //           position: isMobile ? "top-left" : "top-center",
    //         });
    //         navigate("/admin/subscription");
    //       }
    //       setLoader(false);
    //     })
    //     .catch((error) => {
    //       handleToast(error?.response?.data);
    //       setLoader(false);
    //     });
    // } catch (error) {
    //   handleToast(error?.response?.data);
    //   setLoader(false);
    // }
  };

  const handleNumber = (setter) => (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setter(value);
  };

  return (
    <div className="language-top">
      {!loader ? (
        <form id="subscription-form" onSubmit={handleSubmit}>
          <div className="subscription-input">
            <label><h4>Subscription Name</h4></label>
            <input
              type="text"
              value={Name}
              disabled
              style={{ cursor: "not-allowed" }}
            />
          </div>

          <div className="subscription-code">
            <div className="subcode-data">
              <label><h4>Subscription Amount</h4></label>
              <input
                type="text"
                value={Amount}
                onChange={handleNumber(setAmount)}
                style={{ cursor: "not-allowed" }}
                required
                disabled
              />
            </div>

            <div className="subcode-data">
              <label><h4>Is Default</h4></label>
              <Select
                value={state}
                onChange={(e) => setState(e.target.value)}
                className="data-select"
                disabled
                style={{
                  background: "white",
                  width: "100%",
                  height: "48px",
                  border: "0.8px solid #1c1c1c54",
                  borderRadius: "10px",
                  color: "rgba(28, 28, 28, 0.56)",
                  cursor: "not-allowed" 
                }}
              >
                <MenuItem value={true}>True</MenuItem>
                <MenuItem value={false}>False</MenuItem>
              </Select>
            </div>
          </div>

          <div className="subscription-code">
            <div className="subcode-data">
              <label><h4>Coins to Credit</h4></label>
              <input
                type="text"
                disabled
                value={getCoins}
                style={{ cursor: "not-allowed" }}
              />
            </div>
            <div className="subcode-data">
              <label><h4>GST % / Razorpay Amount</h4></label>
              <input
                type="text"
                disabled
                value={finalPriceWithGst ? `${gstPercentage}% — ₹${finalPriceWithGst}` : `${gstPercentage}%`}
                style={{ cursor: "not-allowed" }}
              />
            </div>
          </div>

          <div className="subscription-code">
            <div className="subcode-data">
              <label><h4>Trial Days</h4></label>
              <input
                type="text"
                disabled
                value={trialDays}
                onChange={handleNumber(setTrialDays)}
                style={{ cursor: "not-allowed" }}
                required
              />
            </div>

            <div className="subcode-data">
              <label><h4>Trial Charge</h4></label>
              <input
                type="text"
                disabled
                value={trialCharge}
                style={{ cursor: "not-allowed" }}
                onChange={handleNumber(setTrialCharge)}
                required
              />
            </div>
          </div>

          <div className="subscription-code">
            <div className="subcode-data">
              <label><h4>Duration</h4></label>
              <input
                type="text"
                disabled
                value={duration}
                style={{ cursor: "not-allowed" }}
                onChange={handleNumber(setDuration)}
                required
              />
            </div>

            <div className="subcode-data">
              <label><h4>Timeframe</h4></label>
              <Select
                value={(timeframe).toLowerCase()}
                onChange={(e) => setTimeframe(e.target.value)}
                className="data-select"
                disabled
                style={{
                  background: "white",
                  width: "100%",
                  height: "48px",
                  border: "0.8px solid #1c1c1c54",
                  borderRadius: "10px",
                  color: "rgba(28, 28, 28, 0.56)",
                  cursor: "not-allowed"
                }}
              >
                <MenuItem value="daily">Daily</MenuItem>
                {/* <MenuItem value="weekly">Weekly</MenuItem> */}
                <MenuItem value="monthly">Monthly</MenuItem>
              </Select>
            </div>
          </div>


          <div className="subscription-input">
            <label><h4>Description</h4></label>
            <input
              type="text"
              disabled
              value={description}
              style={{ cursor: "not-allowed" }}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>

  
          <div className="submit">
            <button
              type="button"
              className="button-discard"
              style={{
                cursor: !IsTrue  && 'not-allowed'
              }}
              disabled
              onClick={() => navigate("/admin/subscription")}
            >
              DISCARD
            </button>
            <button
              type="submit"
               style={{
                cursor: !IsTrue  && 'not-allowed',
                background : '#99999981',
                color : '#999'
              }}
              className="button-create"
              disabled={!IsTrue}
            >
              {!IsTrue ? 'Edit' : 'SAVE CHANGES'}
            </button>
          </div>
        </form>
      ) : (
        <div className="loader">
          <CircularProgress style={{ color: "#F99234" }} />
        </div>
      )}
    </div>
  );
}
